import React from 'react'
import './TreatmentText.css'

const ProcedureText = () => {
  return (
    <>
    <div className='treatment-text-section'>
        <h2>Treatment Procedure</h2>
    </div>
    </>
  )
}

export default ProcedureText
